import { render, staticRenderFns } from "./Restauradas.vue?vue&type=template&id=28379dea&scoped=true"
import script from "./Restauradas.vue?vue&type=script&lang=js"
export * from "./Restauradas.vue?vue&type=script&lang=js"
import style0 from "./Restauradas.vue?vue&type=style&index=0&id=28379dea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28379dea",
  null
  
)

export default component.exports